import { t } from "@lingui/macro";
import {StorageKey} from "../../../../enums/StorageKey";

export default {
    storageKey: StorageKey.report_product_bundle_sales_summary,
    getReportLabel: () => t`Product Bundle Sales Summary`,
    getColumns: () => [],
};
